export default __webpack_public_path__ + "static/107986-aec16cb23415ec3d0c7dad87b442a096.jpg";